import React from 'react';
import {MinusOutlined, PlusOutlined} from '@ant-design/icons';
import {StyledAccordion} from './StyledAccordion';

const Accordion = ({
  ...rest
}) => {

  return (
    <StyledAccordion
      ghost
      expandIconPosition='end'
      expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined /> }
      {...rest}
    />
  );
}

export default Accordion;
